import httpService from '@/utils/request'
import { contextPath } from '@/config/'
export const querySubjectListApi = (params) => {
  return httpService({
    url: contextPath + '/subject/info',
    method: 'get',
    params
  })
}

export const queryTempCrawlByUrlApi = (params) => {
  return httpService({
    url: contextPath + '/subject/content/item/tempCrawl',
    method: 'get',
    params
  })
}
